var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$store.state.auth.user)?_c('auth-user-layout'):_c('guest-layout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }